import React from "react";
import { Outlet } from "react-router-dom";

const CertificateUpload = () => {
  return <Outlet />;
};

export default CertificateUpload;
